/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLimitBy = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.025 4h18.95l-6.808 9.269v8.392l-5.334-2.824v-4.131h2v2.927l1.334.706v-5.726L19.025 6H7.975l.29.393-1.613 1.184zM1.41 9h11.18l-3.256 6.789v6.103L4.667 18.71v-2.92zm3.178 2 2.078 4.334v2.32l.666.454v-2.774L9.412 11z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLimitBy as LimitBy };
